import type { ICsvImportMintSocketPayload, IImportCSVMintSummary } from "@redbelly-tokeniser/mystake-api-sdk";
import type { Socket } from "socket.io-client";

export const CSV_IMPORT_MINT_SOCKET_EVENT = "csvImportMintUpdate";

export type CsvImportMintCompleteHandler = (mintBatchId: string, mintSummary: IImportCSVMintSummary) => void;

export const attachCsvImportMintSocketListener = (
  socket: Socket,
  companyId: string,
  getPendingMintBatchIds: () => Set<string>,
  getCompletedMintBatches: () => Map<string, IImportCSVMintSummary>,
  onComplete: CsvImportMintCompleteHandler
): (() => void) => {
  const onUpdate = (payload: ICsvImportMintSocketPayload): void => {
    if (payload.companyId !== companyId || payload.status !== "complete") {
      return;
    }

    const pendingMintBatchIds = getPendingMintBatchIds();
    if (pendingMintBatchIds.has(payload.mintBatchId)) {
      pendingMintBatchIds.delete(payload.mintBatchId);
      onComplete(payload.mintBatchId, payload.mintSummary);
      return;
    }

    // Complete can arrive before the import response registers the batch id.
    getCompletedMintBatches().set(payload.mintBatchId, payload.mintSummary);
  };

  socket.on(CSV_IMPORT_MINT_SOCKET_EVENT, onUpdate);

  return () => {
    socket.off(CSV_IMPORT_MINT_SOCKET_EVENT, onUpdate);
  };
};
